export default {
  phases: {
    phase1: {
      title: 'Phase 1: Foundation Building',
      milestones: {
        protocol: {
          title: 'Core Protocol Development',
          description: 'Complete development of Titron\'s core privacy protection protocol',
          date: 'January 2024'
        },
        testnet: {
          title: 'Testnet Launch',
          description: 'Launch Titron testnet, supporting developer testing',
          date: 'February 2024'
        },
        ecosystem: {
          title: 'Developer Ecosystem',
          description: 'Establish a complete developer ecosystem',
          date: 'May 2025'
        },
        dapps: {
          title: 'First DApps',
          description: 'Launch the first batch of DApp applications based on Titron',
          date: 'December 2025'
        }
      }
    }
  },
  status: {
    completed: 'Completed',
    'in-progress': 'In Progress',
    upcoming: 'Upcoming',
    future: 'Planned'
  }
};
